import React, { useEffect, useRef, useState } from "react";
import Navbar from "../components/Navbar";
import { usePackage } from "../hooks/usePackage";
import { useNavigate, useSearchParams } from "react-router-dom";
import moment from "moment";
import { Paths } from "../router/Paths";
import { SpecialOfferRequest } from "../declarations/specialOffer";

const steps = [
  { step: 1, label: "Products & Options" },
  { step: 2, label: "Details" },
  { step: 3, label: "Discount" },
];

// const packageSuggestedOptions = ["Title","TourManagement",  "TimeManagement ", "TimeSchedule"];
const optionSuggestedOptions = [
  "OptionTitle",
  "OptionSummer",
  "OptionTime ",
  "OptionSchedule ",
];

const SpecialOfferForm = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const {
    specialOffers,
    getSpecialOffers,
    getPackage,
    getSpecialOfferyId,
    updateSpecialOffer,
    getOption,
  } = usePackage();
  const [optionShowDropDown, setOptionShowDropDown] = useState(false);
  const optiondropdownRef: any = useRef(null);
  const [searchInput, setSearchInput] = useState("");
  const [optionInput, setOptionInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [packageSuggestedOptions, setPackageSuggestedOptions] = useState<any>(
    []
  );
  const [SuggestedOptions, setSuggestedOptions] = useState<any>([]);
  const [offerData, setOfferData] = useState<any>();
  const [cachedPackages, setCachedPackages] = useState<Record<string, any>>({});

  const [cachedOptions, setCachedOptions] = useState<Record<string, any>>({});
  const inputRef = useRef<HTMLInputElement>(null);

  const packagedropdownRef = useRef<HTMLDivElement | null>(null);
  const [packageShowDropDown, setPackageShowDropDown] = React.useState(false);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});

  const navigate = useNavigate();

  console.log("suggestd", SuggestedOptions);

  const [searchParams] = useSearchParams();
  const Offer_id: string | null | any = searchParams.get("id");

  const [formData, setFormData] = useState<SpecialOfferRequest>({
    name: "",
    packages: [] as any,
    options: [],
    type: "",
    noticePeriod: 0,
    startDate: "",
    endDate: "",
    amount: 5,
    slotType: "",
    spotType: "",
    spotAmount: null,
  });

  const [packageLoading, setPackageLoading] = useState(false);
  const [optionLoading, setOptionLoading] = useState(false);

  const handleNext = () => {
    const validate = (): boolean => {
      const stepErrors: { [key: string]: string } = {};

      if (currentStep === 1) {
        if (!formData.name.trim()) stepErrors.name = "Name is required.";
        if (formData.packages.length === 0)
          stepErrors.packages = "Select at least one package.";
        if (formData.options.length === 0)
          stepErrors.options = "Select at least one option.";
      } else if (currentStep === 2) {
        if (!formData.type.trim()) stepErrors.type = "Type is required.";
        if (formData.type !== "limited_offer" && formData.noticePeriod <= 0)
          stepErrors.noticePeriod = "Notice period must be greater than 0.";
        if (!formData.startDate.trim())
          stepErrors.startDate = "Start date is required.";
        if (!formData.endDate.trim())
          stepErrors.endDate = "End date is required.";

        // if (!formData.slotType.trim()) stepErrors.slotType = 'Slot type is required.';
      } else if (currentStep === 3) {
        if (!formData.spotType.trim())
          stepErrors.spotType = "Spot type is required.";
        if (formData.spotAmount === null || formData.spotAmount <= 0)
          stepErrors.spotAmount = "Spot amount must be greater than 0.";
        if (formData.amount === null || formData.amount <= 0)
          stepErrors.amount = "Choose a percentage between 5 and 50";
      }

      setErrors(stepErrors);
      return Object.keys(stepErrors).length === 0;
    };

    console.log("error", errors);

    if (validate()) {
      if (currentStep < 3) {
        setCurrentStep((prev) => prev + 1);
      }
      if (currentStep === 3) {
        if (validate()) {
          handleCreateSpecialOffer();
        }
      }
    }
  };

  const handleBack = () => {
    if (currentStep > 1) {
      setCurrentStep((prev) => prev - 1);
    }
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value, type } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    // Remove error for the field if it exists
    if (errors[name]) {
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors[name];
        return newErrors;
      });
    }

    setFormData((prev) => {
      if (name === "packages" || name === "options") {
        return {
          ...prev,
          [name]: value.split(","),
        };
      }

      if (
        name === "noticePeriod" ||
        name === "amount" ||
        name === "spotAmount"
      ) {
        return {
          ...prev,
          [name]: isNaN(+value) ? null : +value,
        };
      }

      if (type === "radio") {
        return {
          ...prev,
          [name]: value,
        };
      }

      return {
        ...prev,
        [name]: value,
      };
    });
  };

  useEffect(() => {
    const handleEdit = async () => {
      try {
        const response = await getSpecialOfferyId(Offer_id);
        console.log("edirespon", response);
        if (response) {
          setFormData({
            name: response.offers.name || "",
            packages:
              response.offers.packages.map((item: string | any) => item._id) ||
              [],
            options: response.options || [],
            type: response.offers.type || "",
            noticePeriod: response.offers.noticePeriod || 0,
            startDate: response.offers.startDate || "",
            endDate: response.offers.endDate || "",
            amount: response.offers.amount || null,
            slotType: "",
            spotType: response.offers.spotType || "",
            spotAmount: response.offers.spotAmount || 10,
          });
        }
        setOfferData(response.offers);
      } catch (error) {
        console.error("Failed to fetch special offer:", error);
      }
    };

    if (Offer_id) {
      handleEdit();
    }
  }, [Offer_id]);

  const handleDropDownPackage = (event: MouseEvent): void => {
    if (
      packagedropdownRef.current &&
      !packagedropdownRef.current.contains(event.target as Node)
    ) {
      setPackageShowDropDown(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleDropDownPackage);
    return () => {
      document.removeEventListener("click", handleDropDownPackage);
    };
  }, []);

  const handlePackageCheckboxToggle = (id: string) => {
    setFormData((prev) => {
      const isSelected = prev.packages.includes(id);

      if (!isSelected) {
        // Find the selected package and cache it
        const selectedPackage = packageSuggestedOptions.packages?.find(
          (pkg: any) => pkg._id === id
        );
        console.log("selec", selectedPackage);
        if (selectedPackage) {
          setCachedPackages((prevCache) => ({
            ...prevCache,
            [id]: selectedPackage, // Cache the entire package object
          }));
        }
      } else {
        // Remove from cache if deselected
        setCachedPackages((prevCache) => {
          const newCache = { ...prevCache };
          delete newCache[id];
          return newCache;
        });
      }

      return {
        ...prev,
        packages: isSelected
          ? prev.packages.filter((packageId: any) => packageId !== id)
          : [...prev.packages, id],
      };
    });
  };

  console.log("cached", cachedPackages);

  const handleOptionCheckboxToggle = (optionId: string) => {
    setFormData((prev) => {
      const options = prev.options.includes(optionId)
        ? prev.options.filter((item) => item !== optionId)
        : [...prev.options, optionId];

      if (!prev.options.includes(optionId)) {
        const selectedOption = SuggestedOptions.options?.find(
          (pkg: any) => pkg._id === optionId
        );
        if (selectedOption) {
          setCachedOptions((prevCache) => ({
            ...prevCache,
            [optionId]: selectedOption.title,
          }));
        }
      } else {
        setCachedOptions((prevCache) => {
          const newCache = { ...prevCache };
          delete newCache[optionId];
          return newCache;
        });
      }

      return { ...prev, options };
    });
  };
  const handleDropDownOption = (event: MouseEvent): void => {
    if (
      optiondropdownRef.current &&
      !optiondropdownRef.current.contains(event.target as Node) &&
      !inputRef.current?.contains(event.target as Node)
    ) {
      setOptionShowDropDown(false);
    }
  };

  useEffect(() => {
    if (optionShowDropDown) {
      document.addEventListener("click", handleDropDownOption);
    }

    return () => {
      document.removeEventListener("click", handleDropDownOption);
    };
  }, [optionShowDropDown]);

  useEffect(() => {
    const getSpecialOfferFunction = async () => {
      await getSpecialOffers();
    };

    getSpecialOfferFunction();
  }, []);

  useEffect(() => {
    if (searchInput.trim()) {
      setPackageLoading(true);
      getPackage(searchInput)
        .then((results) => {
          setPackageSuggestedOptions(results || []);
          setPackageLoading(false);
        })
        .catch(() => {
          setPackageLoading(false);
        });
    } else {
      setPackageSuggestedOptions([]);
    }
  }, [searchInput]);

  console.log("packagedoptio", packageSuggestedOptions);

  useEffect(() => {
    if (optionInput.trim()) {
      setOptionLoading(true);
      getOption(optionInput)
        .then((results) => {
          setSuggestedOptions(results || []);
          setOptionLoading(false);
        })
        .catch(() => {
          setOptionLoading(false);
        });
    } else {
      setSuggestedOptions([]);
    }
  }, [optionInput]);

  console.log("getopt", SuggestedOptions);

  const handleCreateSpecialOffer = async () => {
    try {
      setLoading(true);
      const response = await specialOffers({ formData });
      setLoading(false);
      if (response?.status === 201) {
        navigate(Paths.manageSpecialOffers);
      }
      console.log("Special Offer Created:", response);
    } catch (error) {
      console.error("Error creating special offer:", error);
      alert("Failed to create the special offer. Please try again.");
    }
  };

  const handleUpdateSpecialOffer = async () => {
    try {
      setLoading(true);
      const response = await updateSpecialOffer(formData, Offer_id);
      console.log("resp", response);
      setLoading(false);
      if (response?.status) {
        navigate(Paths.manageSpecialOffers);
      }
      console.log("Special Offer Created:", response);
    } catch (error) {
      console.error("Error creating special offer:", error);
    }
  };

  console.log("formdata", formData);

  return (
    <div>
      <Navbar />
      <div className="max-w-7xl mx-auto">
        <h1 className="font-bold mt-12 mb-6 text-4xl">
          Create a Special Offer
        </h1>
        <div className="bg-gray-100 flex justify-between items-center mx-auto p-6">
          <div className="w-full bg-white p-6 shadow-md rounded-lg my-7">
            <h1 className="text-xl font-bold mb-4">Create a Special Offer</h1>
            <p className="text-gray-600 mb-4">
              Sell more tickets with special offers. Give customers discounted
              prices for a limited time.{" "}
              <a href="#" className="text-blue-500 underline">
                Learn more
              </a>
            </p>

            <div className="flex items-center gap-6 mb-6 flex-wrap">
              {steps.map(({ step, label }) => (
                <div
                  key={step}
                  className="flex items-center space-x-3 cursor-pointer"
                  onClick={() => setCurrentStep(step)}
                >
                  <div
                    className={`flex items-center justify-center w-8 h-8 rounded-full flex-shrink-0 ${
                      currentStep >= step
                        ? "bg-blue-600 text-white"
                        : "bg-gray-300 text-gray-600"
                    }`}
                  >
                    {currentStep > step ? "✓" : step}
                  </div>
                  <span
                    className={`${
                      currentStep === step
                        ? "text-black font-medium"
                        : "text-gray-500"
                    }`}
                  >
                    {label}
                  </span>
                  {step !== 3 && (
                    <span
                      className={`h-[2px] w-8 ${
                        currentStep > step ? "bg-blue-600" : "bg-gray-300"
                      }`}
                    ></span>
                  )}
                </div>
              ))}
            </div>

            {/* Step 1: Product and Options */}
            {currentStep === 1 && (
              <div>
                <label className="block mb-2 font-medium">
                  Special offer name
                  <span className="block text-sm text-gray-500">
                    This is for your own use, customers won't see this.
                  </span>
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded px-4 py-2 mb-4"
                  placeholder="e.g Valantine's day 2024"
                />
                {errors.name && <p className="text-red-500">{errors.name}</p>}

                {/* Package Dropdown */}
                <div className="relative">
                  <label className="block mb-2 font-medium">
                    Product and option
                  </label>
                  <input
                    type="text"
                    value={searchInput}
                    onChange={(e) => {
                      setSearchInput(e.target.value);
                      setPackageShowDropDown(true);
                    }}
                    onFocus={() => setPackageShowDropDown(true)}
                    placeholder="Product name..."
                    className="w-full border border-gray-300 rounded px-4 py-2"
                  />
                  {errors.packages && (
                    <p className="text-red-500">{errors.packages}</p>
                  )}

                  {packageShowDropDown && (
                    <div
                      ref={packagedropdownRef}
                      className="absolute left-0 right-0 mt-1 bg-white border border-gray-300 rounded-md shadow-md z-10 "
                    >
                      {packageLoading ? (
                        <div className="flex items-center justify-center p-4">
                          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-primary1"></div>
                        </div>
                      ) : packageSuggestedOptions.packages?.length === 0 ? (
                        <div className="px-4 py-2 text-gray-500">
                          No packages found
                        </div>
                      ) : (
                        packageSuggestedOptions.packages
                          ?.filter((option: any) =>
                            option.title
                              .toLowerCase()
                              .includes(searchInput.toLowerCase())
                          )
                          .map((option: any, index: any) => (
                            <div
                              key={index}
                              className="flex items-center px-4 py-2 cursor-pointer hover:bg-gray-100 overflow-y-hidden "
                            >
                              <input
                                type="checkbox"
                                id={`option-${index}`}
                                className="mr-2 cursor-pointer overflow-y-hidden"
                                checked={formData.packages.includes(option._id)}
                                onChange={() =>
                                  handlePackageCheckboxToggle(option._id)
                                }
                              />
                              <label
                                htmlFor={`option-${index}`}
                                className="cursor-pointer overflow-y-hidden"
                              >
                                {option.title}
                              </label>
                            </div>
                          ))
                      )}
                    </div>
                  )}
                </div>

                <div className="flex flex-wrap gap-2 my-3 overflow-y-auto max-h-48">
                  {formData.packages.map((id: any, index: any) => {
                    // const selectedPackage =
                    //   packageSuggestedOptions.packages?.find(
                    //     (pkg: any) => pkg._id === id
                    //   )

                    return (
                      <div
                        key={index}
                        className="flex items-center px-3 py-1 text-sm bg-gray-100 border border-gray-300 rounded-full"
                      >
                        <label
                          htmlFor={`option-${index}`}
                          className="cursor-pointer"
                        >
                          {Offer_id && offerData?.packages?.length > 0
                            ? offerData.packages[index]?.title
                            : cachedPackages[id]?.title}
                        </label>

                        {/* <span>{selectedPackage?.title }</span> */}
                        <button
                          onClick={() => handlePackageCheckboxToggle(id)}
                          className="ml-2 text-gray-500 hover:text-gray-700 focus:outline-none"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={2}
                            stroke="currentColor"
                            className="w-4 h-4"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M6 18L18 6M6 6l12 12"
                            />
                          </svg>
                        </button>
                      </div>
                    );
                  })}
                </div>

                <div className="relative">
                  <input
                    ref={optiondropdownRef}
                    type="text"
                    value={optionInput}
                    onChange={(e) => {
                      setOptionInput(e.target.value);
                      setOptionShowDropDown(true);
                    }}
                    onFocus={() => setOptionShowDropDown(true)}
                    placeholder="Option name..."
                    className="w-full border border-gray-300 rounded px-4 py-2"
                  />
                  {errors.options && (
                    <p className="text-red-500">{errors.options}</p>
                  )}

                  {optionShowDropDown && (
                    <div
                      ref={inputRef}
                      className="absolute left-0 right-0 mt-1 bg-white border border-gray-300 rounded-md shadow-md z-10"
                    >
                      {optionLoading ? (
                        <div className="flex items-center justify-center p-4">
                          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-primary1"></div>
                        </div>
                      ) : SuggestedOptions.options?.length === 0 ? (
                        <div className="px-4 py-2 text-gray-500">
                          No options found
                        </div>
                      ) : (
                        SuggestedOptions.options
                          ?.filter((pkg: any) =>
                            pkg?.title
                              ?.toLowerCase()
                              .includes(optionInput.toLowerCase())
                          )
                          .map((pkg: any) => (
                            <div
                              key={pkg._id}
                              className="flex items-center px-4 py-2 cursor-pointer hover:bg-gray-100"
                            >
                              <input
                                type="checkbox"
                                id={`option-${pkg._id}`}
                                className="mr-2 cursor-pointer"
                                checked={formData.options.includes(pkg._id)}
                                onChange={() =>
                                  handleOptionCheckboxToggle(pkg._id)
                                }
                              />
                              <label
                                htmlFor={`option-${pkg._id}`}
                                className="cursor-pointer"
                              >
                                {Offer_id && offerData?.options?.length > 0
                                  ? offerData.packages[pkg]?.options.title
                                  : pkg?.title}
                              </label>
                            </div>
                          ))
                      )}
                    </div>
                  )}
                </div>
                <div className="flex flex-wrap gap-2 my-3">
                  {formData.options.map((id) => (
                    <div
                      key={id}
                      className="flex items-center px-3 py-1 text-sm bg-gray-100 border border-gray-300 rounded-full"
                    >
                      <span>{cachedOptions[id] || "Option not found"}</span>
                      <button
                        onClick={() => handleOptionCheckboxToggle(id)}
                        className="ml-2 text-gray-500 hover:text-gray-700"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={2}
                          stroke="currentColor"
                          className="w-4 h-4"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M6 18L18 6M6 6l12 12"
                          />
                        </svg>
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {currentStep === 2 && (
              <div>
                {/* Date Range */}
                <label className="block mb-2 font-medium">
                  What's the date range for the special offer?
                </label>
                <div className="flex space-x-4 justify-between ">
                  <div className="w-full">
                    <input
                      type="date"
                      name="startDate"
                      value={moment(formData.startDate).format("YYYY-MM-DD")}
                      onChange={handleChange}
                      className="w-full border border-gray-300 rounded px-4 py-2"
                    />
                    {errors.startDate && (
                      <p className="text-red-500">{errors.startDate}</p>
                    )}
                  </div>

                  <div className="w-full">
                    <input
                      type="date"
                      name="endDate"
                      value={moment(formData.endDate).format("YYYY-MM-DD")}
                      onChange={handleChange}
                      className="w-full border border-gray-300 rounded px-4 py-2"
                    />
                    {errors.endDate && (
                      <p className="text-red-500 ">{errors.endDate}</p>
                    )}
                  </div>
                </div>

                <div className="flex items-center mb-4 last:justify-end"></div>

                {/* Special Offer Type */}
                <label className="block mb-2 font-medium">
                  What type of special offer is it?
                </label>
                <div className="space-y-2 mb-4">
                  <div className="flex items-start">
                    <input
                      type="radio"
                      id="limitedOffer"
                      name="type"
                      value="limited_offer"
                      checked={formData.type === "limited_offer"}
                      onChange={handleChange}
                      className="mr-2 mt-1"
                    />

                    <label htmlFor="limitedOffer" className="text-gray-700">
                      Limited-time offer
                      <p className="text-sm text-gray-500">
                        Attract customers to activity dates and time slots you
                        struggle to fill, e.g., Monday mornings
                      </p>
                    </label>
                  </div>

                  <div className="flex items-start">
                    <input
                      type="radio"
                      id="earlyBirdOffer"
                      name="type"
                      value="early_bird"
                      checked={formData.type === "early_bird"}
                      onChange={handleChange}
                      className="mr-2 mt-1"
                    />
                    <label htmlFor="earlyBirdOffer" className="text-gray-700">
                      early_bird offer
                      <p className="text-sm text-gray-500">
                        To attract bookings at least{" "}
                        {formData.noticePeriod || 0} days in advance
                      </p>
                    </label>
                  </div>
                  <div className="flex items-start">
                    <input
                      type="radio"
                      id="lastMinuteOffer"
                      name="type"
                      value="last_minute"
                      checked={formData.type === "last_minute"}
                      onChange={handleChange}
                      className="mr-2 mt-1"
                    />
                    <label htmlFor="lastMinuteOffer" className="text-gray-700">
                      Last-minute offer
                      <p className="text-sm text-gray-500">
                        For activities happening very soon, e.g., in 3 days'
                        time
                      </p>
                    </label>
                  </div>
                </div>
                {errors.type && <p className="text-red-500">{errors.type}</p>}

                {/* Notice Period */}
                {formData.type === "early_bird" && (
                  <div>
                    <label className="block mb-2 font-medium">
                      Notice Period: early_bird offer
                    </label>
                    <input
                      type="text"
                      name="noticePeriod"
                      value={formData.noticePeriod || ""}
                      onChange={handleChange}
                      className="border border-gray-300 rounded px-4 py-2 mb-4"
                      placeholder="Enter number of days"
                    />
                    {formData.noticePeriod
                      ? formData.noticePeriod >=
                          calculateDaysBeforeStart(formData.startDate) && (
                          <p className="text-sm text-red-500">
                            Must be smaller than the number of days before the
                            special offer begins
                          </p>
                        )
                      : null}
                  </div>
                )}

                {formData.type === "last_minute" && (
                  <div>
                    <label className="block mb-2 font-medium">
                      Notice Period: Last-minute offer
                    </label>
                    <input
                      type="number"
                      name="noticePeriod"
                      value={formData.noticePeriod || ""}
                      onChange={handleChange}
                      className="border border-gray-300 rounded px-4 py-2 mb-4"
                      placeholder="Enter number of days"
                    />

                    {/* {formData.noticePeriod >= calculateDaysBeforeStart(formData.startDate) && (
                            <p className="text-sm text-red-500">
                                Must be smaller than the number of days before the special offer begins
                            </p>
                            )} */}
                  </div>
                )}

                {formData.type === "early_bird" ||
                  (formData.type === "last_minute" && errors.noticePeriod && (
                    <p className="text-red-500">{errors.noticePeriod}</p>
                  ))}

                <label className="block mb-2 font-medium">
                  Which time slots are included?
                </label>
                <div className="space-y-2 mb-4">
                  <div className="flex items-start">
                    <input
                      type="radio"
                      id="allTimeSlots"
                      name="slotType"
                      value="all_day" // Align with formData.spotType
                      checked={formData.slotType === "all_day"}
                      onChange={handleChange}
                      className="mr-2 mt-1"
                    />
                    <label htmlFor="allTimeSlots" className="text-gray-700">
                      Include all days and time slots
                    </label>
                  </div>

                  <div className="flex items-start">
                    <input
                      type="radio"
                      id="specificTimeSlots"
                      name="slotType"
                      value="Weekday"
                      checked={formData.slotType === "Weekday"}
                      onChange={handleChange}
                      className="mr-2 mt-1"
                    />
                    <label
                      htmlFor="specificTimeSlots"
                      className="text-gray-700"
                    >
                      Include specific weekdays and time slots
                    </label>
                  </div>
                </div>

                {formData.slotType === "Weekday" && (
                  <div>
                    <p className="text-sm text-gray-500">
                      [Add your specific weekday/time slot fields here]
                    </p>
                    {/* Add fields for selecting specific weekdays and time slots */}
                  </div>
                )}
              </div>
            )}

            {currentStep === 3 && (
              <div>
                <label className="block mb-2 font-medium">Spot Type</label>
                <div className="space-y-2 mb-4">
                  <div className="flex items-start">
                    <input
                      type="radio"
                      id="allBookings"
                      name="spotType"
                      value="all_bookings"
                      checked={formData.spotType === "all_bookings"}
                      onChange={handleChange}
                      className="mr-2 mt-1"
                    />
                    <label htmlFor="allBookings" className="text-gray-700">
                      <span className="font-medium">
                        Include all Bookable spots available
                      </span>
                    </label>
                  </div>

                  <div className="flex items-start">
                    <input
                      type="radio"
                      id="limitedSpots"
                      name="spotType"
                      value="limited_number"
                      checked={formData.spotType === "limited_number"}
                      onChange={handleChange}
                      className="mr-2 mt-1"
                    />
                    <label htmlFor="limitedSpots" className="text-gray-700">
                      <span className="font-medium">A limited Number</span>
                    </label>
                  </div>
                </div>

                {formData.spotType === "limited_number" && (
                  <div>
                    {/* <label className="block mb-2 font-medium">Number of Spots</label> */}
                    <input
                      type="number"
                      name="spotAmount"
                      value={formData.spotAmount || ""}
                      onChange={handleChange}
                      className="border border-gray-300 rounded px-4 py-2 mb-4"
                      placeholder="Enter number of spots"
                    />
                  </div>
                )}
                {errors.spotType && (
                  <p className="text-red-500">{errors.spotType}</p>
                )}

                <label className="block mb-2 font-medium">
                  What discount do you want to offer %
                </label>
                <input
                  type="number"
                  name="amount"
                  value={formData.amount || ""}
                  onChange={handleChange}
                  className="w-14 border border-gray-300 rounded py-2 bg-gray-100 text-center"
                  placeholder=""
                />
              </div>
            )}

            <div className="flex justify-end gap-4 mt-6">
              <button
                onClick={handleBack}
                className="bg-gray-300 text-gray-700 px-4 py-2 rounded"
                disabled={currentStep === 1}
              >
                Back
              </button>
              {currentStep < 3 ? (
                <button
                  onClick={handleNext}
                  className="bg-blue-500 text-white px-4 py-2 rounded"
                >
                  Next
                </button>
              ) : (
                <button
                  onClick={
                    Offer_id
                      ? handleUpdateSpecialOffer
                      : handleCreateSpecialOffer
                  }
                  className="bg-blue-500 text-white px-4 py-2 rounded"
                >
                  {loading
                    ? "Please Wait..."
                    : Offer_id
                    ? "Update Special Offer"
                    : "Create Special Offer"}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpecialOfferForm;

const calculateDaysBeforeStart = (startDate: any) => {
  const today: any = new Date();
  const start: any = new Date(startDate);
  const diff = Math.ceil((start - today) / (1000 * 60 * 60 * 24));
  return diff;
};
